import Dialog from '@mui/material/Dialog'

import type { Entity } from '@models/Entity'
import type { GroupedOption } from '@models/GroupedOption'

import type { Project } from '../../../aansluiting/project/types/Project'
import type { GeblokkeerdeWeek } from '../../../planning/types/GeblokkeerdeWeek'
import type { Activiteit } from '../types/Activiteit'

import { CancelActiviteitDialog } from './dialogs/CancelActiviteitDialog'
import { CreateEditActiviteitDialog } from './dialogs/CreateEditActiviteitDialog'
import { FinishActiviteitDialog } from './dialogs/FinishActiviteitDialog'

type Props = {
  type?: 'create' | 'edit' | 'resolve' | 'cancel'
  activiteit?: Activiteit
  entity: Entity
  assignees: GroupedOption[]
  entityProps?: Partial<Project>
  onClose: () => void
  geblokkeerdeWeken: GeblokkeerdeWeek[]
}

export const ActiviteitenDialog = ({
  type,
  activiteit,
  assignees,
  entity,
  entityProps,
  onClose,
  geblokkeerdeWeken,
}: Props) => {
  if (!type) return null

  return (
    <Dialog open fullWidth maxWidth={'lg'}>
      {type === 'resolve' && activiteit && (
        <FinishActiviteitDialog activiteit={activiteit} onClose={onClose} />
      )}
      {(type === 'create' || type === 'edit') && (
        <CreateEditActiviteitDialog
          activiteit={activiteit}
          onClose={onClose}
          assignees={assignees}
          entityProps={entityProps}
          entity={entity}
          isEdit={type === 'edit'}
          geblokkeerdeWeken={geblokkeerdeWeken}
        />
      )}
      {type === 'cancel' && activiteit && (
        <CancelActiviteitDialog activiteit={activiteit} onClose={onClose} />
      )}
    </Dialog>
  )
}
